<script>
    export let qrImage;
    export let hint;
    export let moreHint;
</script>
<div class="qr-block">

    <img class="channel-qr qr-code" alt="QR code" src={qrImage}>
    <div class="qr-hint">
        <div>{hint}</div>
        <div>{moreHint}</div>
    </div>
</div>

<style>
    .qr-block {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .qr-hint {
        font-weight: 400;
        transform: scale(calc(11/12));
        font-size: 12px;
        line-height: 15px;
        color: #747474;

        text-align: center;
        margin-top: 4px;
    }

    .qr-block img {
        background: #FFFFFF;
        box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.13);
        width: 68px;
        border: 8px solid white;
        border-radius: 4px;
    }
</style>
